import {
  LANDING_UPDATE_CAMPAIGNS,
  LANDING_UPDATE_STATIC_CONTENT,
  GET_UPDATE_FILTERS,
  CAMPAIGN_PARENT_ID,
  PARTNERS_NO_CONTRACT
} from 'store/actions/landing';

export default {
  [LANDING_UPDATE_CAMPAIGNS]: (state, catalog) => {
    state.catalog = catalog;
  },

  [LANDING_UPDATE_STATIC_CONTENT]: (state, content) => {
    state.static = content;
  },

  [GET_UPDATE_FILTERS]: (state, content) => {
    state.filters = content;
  },

  [CAMPAIGN_PARENT_ID]: (state, campaignParentId) => {
    state.campaignParentId = campaignParentId;
  },

  [PARTNERS_NO_CONTRACT]: (state, partnersNoContract) => {
    state.partnersNoContract = partnersNoContract;
  }
};
